import React, { useMemo } from 'react'

import { Flex, Text, Button as ButtonBase, SVG } from 'system'

const getColors = colorScheme => {
  switch (colorScheme) {
    case 'white':
      return {
        bg: 'purple.100',
        bgHover: 'white',
        color: 'purple.50',
        colorHover: 'purple.40',
      }

    case 'green':
      return {
        bg: 'green.50',
        bgHover: 'green.60',
        color: 'white',
        colorHover: 'white',
      }

    case 'purple':
    default:
      return {
        bg: 'purple.50',
        bgHover: 'purple.40',
        color: 'white',
        colorHover: 'white',
      }
  }
}

export const Button = ({
  children,
  iconPosition = 'before',
  iconSVG,
  colorScheme = 'purple',
  textAlign = 'center',
  ...props
}) => {
  const isIconBefore = iconPosition === 'before'
  const colors = useMemo(() => getColors(colorScheme), [colorScheme])

  return (
    <ButtonBase
      bg={colors.bg}
      borderRadius="4px"
      color={colors.color}
      cursor="pointer"
      fontSizeScale="small"
      fontWeight="semibold"
      lineHeight="solid"
      pxScale="s"
      pyScale="s-"
      {...props}
    >
      <Flex alignItems="center" justifyContent={textAlign} minHeight="1rem">
        {iconSVG && (
          <SVG
            x={1}
            y={1}
            svg={iconSVG}
            fill={colors.color}
            flex="0 0 auto"
            height="1rem"
            ml={isIconBefore ? 0 : 1}
            mr={isIconBefore ? 1 : 0}
            order={isIconBefore ? 0 : 1}
            width="1rem"
          />
        )}
        <Text order={iconPosition === 'before' ? 1 : 0} textAlign="left">
          {children}
        </Text>
      </Flex>
    </ButtonBase>
  )
}
